module.exports = __webpack_public_path__ + "static/media/PeterTsemberides.6f956e63.webp";